import { cn } from "@/lib/utils";

interface FieldGroupProps {
    fieldName: string;
    children?: React.ReactNode;
    headerAction?: React.ReactNode;
    className?: string;
}

export function FieldGroup({
    fieldName,
    children,
    headerAction,
    className,
}: FieldGroupProps) {
    return (
        <div className={cn("group/field-group", className)}>
            <div className="flex min-h-7 items-center justify-between gap-2 py-1">
                <span className="text-foreground text-[13px] leading-tight font-medium tracking-[-0.01em]">
                    {fieldName}
                </span>
                {headerAction && (
                    <div className="shrink-0 opacity-0 transition-opacity duration-150 group-hover/field-group:opacity-100">
                        {headerAction}
                    </div>
                )}
            </div>
            <div className="border-border/80 ml-0.5 border-l-2 py-0.5 pl-2.5">
                {children ?? (
                    <span className="text-muted-foreground/60 block py-0.5 text-[13px] italic">
                        Not found
                    </span>
                )}
            </div>
        </div>
    );
}
